import { ChatMessage } from "@/components/chat/chat-message";
import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/ui/stepper";
import { useAIMessageStream } from "@/hooks/useAIMessageStream";
import { useTranslation } from "@/hooks/useTranslation";
import { FiChevronRight } from "react-icons/fi";

export const SetupTeamCreationAIResumePage = () => {
  const { nextStep, prevStep } = useStepper();
  const { t } = useTranslation();

  const { assistantMessage, status } = useAIMessageStream({
    streamUrl: "/my/team/setup/ai-summary",
    launchFetch: true,
  });

  return (
    <div className="text-center w-full max-w-[800px] space-y-5">
      <div className="text-left">
        {assistantMessage && (
          <ChatMessage
            message={assistantMessage}
            isLastMessage
            status={status}
            streamInProgress={status === "streaming"}
          />
        )}
      </div>

      <div className="space-x-2">
        <Button onClick={() => prevStep(2)} variant="outline">
          {t("setup.teamCreation.aiResume.buttons.previous")}
        </Button>
        <Button onClick={nextStep}>
          {t("setup.teamCreation.aiResume.buttons.continue")}
          <FiChevronRight className="ml-2 w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
